import { useIntl } from '@/intl'
import { useBookingDetailsStore } from '@/scopes/account/booking-details/infrastructure/useBookingDetailsStore'
import { CancelBookingAction } from '@/scopes/account/booking-details/pages/components/CancelBookingAction'
import { DeleteAction } from '@/scopes/account/booking-details/pages/components/ManageBookingSection/DeleteAction'
import { RebookAction } from '@/scopes/account/booking-details/pages/components/ManageBookingSection/RebookAction'
import { getIsManageBookingSectionShown, getManageBookingDescriptionKey } from '@/scopes/account/booking-details/pages/selectors'
import { BookingDetailsSection } from '../BookingDetailsSection'
import styles from './ManageBookingSection.module.css'

export function ManageBookingSection() {
  const { formatMessage } = useIntl()
  const shouldBeShown = useBookingDetailsStore(getIsManageBookingSectionShown)
  const descriptionKey = useBookingDetailsStore(getManageBookingDescriptionKey)

  if (!shouldBeShown) {
    return null
  }

  return (
    <BookingDetailsSection
      iconName="Gear"
      title={formatMessage({ id: 'booking_details_manage_booking_title' })}
      description={formatMessage({ id: descriptionKey })}
    >
      <div className={styles.actionsWrapper}>
        <RebookAction />
        <DeleteAction />
        <CancelBookingAction />
      </div>
    </BookingDetailsSection>
  )
}
